"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsSortKeysType = void 0;
var NotificationsSortKeysType;
(function (NotificationsSortKeysType) {
    NotificationsSortKeysType["CreatedAt"] = "createdAt";
})(NotificationsSortKeysType = exports.NotificationsSortKeysType || (exports.NotificationsSortKeysType = {}));
